(function(){
  "use strict";

  function initChessPuzzle(root){
    var STORAGE_KEY = "dailyChessPuzzle_v1";
    var EPOCH_UTC = Date.UTC(2025, 0, 1);
    var TOTAL = 0;
    var PUZZLES = [];

    function todayIndex(){
      var d = new Date();
      var utcMidnight = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
      var days = Math.floor((utcMidnight - EPOCH_UTC) / 86400000);
      return ((days % TOTAL) + TOTAL) % TOTAL;
    }
    function localDateStr(){
      var d = new Date();
      return d.getFullYear() + "-" + String(d.getMonth()+1).padStart(2,"0") + "-" + String(d.getDate()).padStart(2,"0");
    }
    function yesterdayStr(){
      var d = new Date();
      d.setDate(d.getDate() - 1);
      return d.getFullYear() + "-" + String(d.getMonth()+1).padStart(2,"0") + "-" + String(d.getDate()).padStart(2,"0");
    }
    function loadProgress(){
      try{
        var raw = localStorage.getItem(STORAGE_KEY);
        if (raw) return JSON.parse(raw);
      }catch(e){}
      return { solvedDays: [], streak: 0, bestStreak: 0, lastDailyDate: null };
    }
    function saveProgress(p){
      try{ localStorage.setItem(STORAGE_KEY, JSON.stringify(p)); }catch(e){}
    }

    var progress = loadProgress();
    var TODAY_IDX = 0;

    function $(role){ return root.querySelector('[data-role="' + role + '"]'); }

    var boardEl = $("board");
    var ranksEl = $("ranks");
    var filesEl = $("files");
    var statusEl = $("status");
    var tagNumber = root.querySelector('[data-role="tag-number"] strong');
    var tagRating = root.querySelector('[data-role="tag-rating"] strong');
    var tagTurn = root.querySelector('[data-role="tag-turn"] strong');
    var navLabel = $("nav-label");
    var solvedPanel = $("solved-panel");
    var statStreak = $("stat-streak");
    var statSolved = $("stat-solved");
    var statBest = $("stat-best");

    var viewIndex = 0;
    var puzzle = null;
    var game = null;
    var ply = 0;
    var orientation = "w";
    var selected = null;
    var legalTargets = [];
    var solved = false;
    var hintUsed = false;
    var lastMoveSquares = null;

    function uciParts(uci){
      return { from: uci.slice(0,2), to: uci.slice(2,4), promotion: uci.length > 4 ? uci.slice(4,5) : undefined };
    }

    function loadPuzzle(index){
      viewIndex = index;
      puzzle = PUZZLES[index];
      game = new window.Chess(puzzle.fen);
      var setupMove = uciParts(puzzle.moves[0]);
      game.move(setupMove);
      ply = 1;
      orientation = game.turn();
      selected = null;
      legalTargets = [];
      solved = false;
      hintUsed = false;
      lastMoveSquares = { from: setupMove.from, to: setupMove.to };
      solvedPanel.innerHTML = "";

      tagNumber.textContent = String(index + 1).padStart(3,"0");
      tagRating.textContent = puzzle.rating;
      tagTurn.textContent = orientation === "w" ? "White" : "Black";
      navLabel.textContent = "Browsing puzzle " + (index+1) + " of " + TOTAL + (index===TODAY_IDX ? " (today)" : "");
      setStatus((orientation === "w" ? "White" : "Black") + " to move. Find the winning move.", "");

      renderBoard();
      updateStats();
    }

    function setStatus(text, cls){
      statusEl.textContent = text;
      statusEl.className = "chess-puzzle-app__status" + (cls ? " " + cls : "");
    }

    function squareColor(fileIdx, rank){
      return ((fileIdx + rank) % 2 === 0) ? "is-dark" : "is-light";
    }

    function renderCoordinates(){
      ranksEl.innerHTML = "";
      filesEl.innerHTML = "";
      var ranks = [8,7,6,5,4,3,2,1];
      var files = ["a","b","c","d","e","f","g","h"];
      if (orientation === "b"){ ranks = ranks.slice().reverse(); files = files.slice().reverse(); }
      ranks.forEach(function(r){
        var s = document.createElement("span");
        s.textContent = r;
        ranksEl.appendChild(s);
      });
      files.forEach(function(f){
        var s = document.createElement("span");
        s.textContent = f;
        filesEl.appendChild(s);
      });
    }

    function renderBoard(){
      renderCoordinates();
      boardEl.innerHTML = "";
      var files = ["a","b","c","d","e","f","g","h"];
      var ranks = [8,7,6,5,4,3,2,1];
      if (orientation === "b"){ files = files.slice().reverse(); ranks = ranks.slice().reverse(); }

      var boardState = game.board();
      var checkSquare = null;
      if (game.inCheck()){
        var turnColor = game.turn();
        for (var rr=0; rr<8; rr++){
          for (var ff=0; ff<8; ff++){
            var p = boardState[rr][ff];
            if (p && p.type === "k" && p.color === turnColor) checkSquare = p.square;
          }
        }
      }

      ranks.forEach(function(rank){
        files.forEach(function(file){
          var square = file + rank;
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "chess-puzzle-app__square " + squareColor("abcdefgh".indexOf(file), rank);
          btn.dataset.square = square;
          btn.setAttribute("aria-label", square);

          var piece = game.get(square);
          if (piece){
            var svgNS = "http://www.w3.org/2000/svg";
            var svg = document.createElementNS(svgNS, "svg");
            svg.setAttribute("class", "chess-puzzle-app__piece");
            var use = document.createElementNS(svgNS, "use");
            use.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#pc-" + piece.type);
            use.setAttribute("href", "#pc-" + piece.type);
            svg.appendChild(use);
            svg.style.fill = piece.color === "w" ? "#F6EFD9" : "#2A241C";
            svg.style.stroke = piece.color === "w" ? "#6B5B3E" : "#F1E4C9";
            svg.style.strokeWidth = "2.5";
            btn.appendChild(svg);
          }

          if (selected === square) btn.classList.add("is-selected");
          if (lastMoveSquares && lastMoveSquares.from === square) btn.classList.add("is-last-from");
          if (lastMoveSquares && lastMoveSquares.to === square) btn.classList.add("is-last-to");
          if (checkSquare === square) btn.classList.add("is-check");
          var targetMatch = legalTargets.find(function(t){ return t.to === square; });
          if (targetMatch){
            btn.classList.add("is-target");
            if (piece) btn.classList.add("has-piece");
          }

          btn.addEventListener("click", function(){ onSquareClick(square); });
          boardEl.appendChild(btn);
        });
      });
    }

    function onSquareClick(square){
      if (solved) return;
      if (game.turn() !== orientation) return;

      if (selected){
        var match = legalTargets.find(function(t){ return t.to === square; });
        if (match){
          if (match.needsPromotion){
            askPromotion(function(piece){ tryMove(selected, square, piece); });
          } else {
            tryMove(selected, square, match.promotion);
          }
          return;
        }
      }

      var piece = game.get(square);
      if (piece && piece.color === orientation){
        selectSquare(square);
      } else {
        selected = null;
        legalTargets = [];
        renderBoard();
      }
    }

    function selectSquare(square){
      selected = square;
      var moves = game.moves({ square: square, verbose: true });
      var byTarget = {};
      moves.forEach(function(m){
        if (!byTarget[m.to]) byTarget[m.to] = { to: m.to, promotion: m.promotion, needsPromotion: false };
        if (m.promotion) byTarget[m.to].needsPromotion = true;
      });
      legalTargets = Object.keys(byTarget).map(function(k){ return byTarget[k]; });
      renderBoard();
    }

    function askPromotion(callback){
      var overlay = document.createElement("div");
      overlay.className = "chess-puzzle-app__promo-overlay";
      var box = document.createElement("div");
      box.className = "chess-puzzle-app__promo-box";
      ["q","r","b","n"].forEach(function(p){
        var btn = document.createElement("button");
        btn.type = "button";
        var svgNS = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(svgNS, "svg");
        svg.setAttribute("viewBox","0 0 100 100");
        var use = document.createElementNS(svgNS, "use");
        use.setAttribute("href", "#pc-" + p);
        svg.appendChild(use);
        svg.style.fill = orientation === "w" ? "#F6EFD9" : "#2A241C";
        svg.style.stroke = orientation === "w" ? "#6B5B3E" : "#F1E4C9";
        svg.style.strokeWidth = "2.5";
        btn.appendChild(svg);
        btn.addEventListener("click", function(){
          document.body.removeChild(overlay);
          callback(p);
        });
        box.appendChild(btn);
      });
      overlay.appendChild(box);
      document.body.appendChild(overlay);
    }

    function tryMove(from, to, promotion){
      var isLastPly = (ply === puzzle.moves.length - 1);
      var result;
      try{
        result = game.move({ from: from, to: to, promotion: promotion });
      }catch(e){
        selected = null; legalTargets = [];
        renderBoard();
        return;
      }

      var uciPlayed = from + to + (promotion || "");
      var matchesSolution = (uciPlayed === puzzle.moves[ply]);
      var isMateAccepted = isLastPly && result.san.indexOf("#") !== -1;

      if (matchesSolution || isMateAccepted){
        ply++;
        selected = null; legalTargets = [];
        lastMoveSquares = { from: from, to: to };
        renderBoard();

        if (ply >= puzzle.moves.length){
          finishPuzzle();
        } else {
          setStatus("Good move.", "is-good");
          window.setTimeout(function(){
            var reply = uciParts(puzzle.moves[ply]);
            game.move(reply);
            lastMoveSquares = { from: reply.from, to: reply.to };
            ply++;
            renderBoard();
            if (ply >= puzzle.moves.length){
              finishPuzzle();
            } else {
              setStatus((orientation === "w" ? "White" : "Black") + " to move. Find the winning move.", "");
            }
          }, 450);
        }
      } else {
        game.undo();
        selected = null; legalTargets = [];
        renderBoard();
        var flashEl = boardEl.querySelector('[data-square="' + to + '"]');
        if (flashEl){
          flashEl.classList.add("is-wrong");
          window.setTimeout(function(){ flashEl.classList.remove("is-wrong"); }, 260);
        }
        setStatus("Not quite. Try again.", "is-bad");
      }
    }

    function useHint(){
      if (solved || !puzzle) return;
      var next = uciParts(puzzle.moves[ply]);
      var el = boardEl.querySelector('[data-square="' + next.from + '"]');
      if (el){
        el.classList.add("is-selected");
        window.setTimeout(function(){ el.classList.remove("is-selected"); }, 900);
      }
      hintUsed = true;
      setStatus("Hint: look at the piece on " + next.from + ".", "");
    }

    function finishPuzzle(){
      solved = true;
      setStatus("Solved! Well done.", "is-good");

      var isToday = (viewIndex === TODAY_IDX);
      if (isToday){
        var today = localDateStr();
        if (progress.lastDailyDate !== today){
          progress.streak = (progress.lastDailyDate === yesterdayStr()) ? progress.streak + 1 : 1;
          progress.bestStreak = Math.max(progress.bestStreak, progress.streak);
          progress.lastDailyDate = today;
        }
      }
      if (progress.solvedDays.indexOf(viewIndex) === -1) progress.solvedDays.push(viewIndex);
      saveProgress(progress);
      updateStats();

      var themeText = puzzle.themes.join(", ");
      solvedPanel.innerHTML =
        '<div class="chess-puzzle-app__solved-panel">' +
        'Rated ' + puzzle.rating + '. Themes: ' + themeText + '.' +
        (hintUsed ? ' Solved with a hint.' : '') +
        ' <a href="' + puzzle.gameUrl + '" target="_blank" rel="noopener">View the source game</a>.' +
        '</div>';
    }

    function updateStats(){
      statStreak.textContent = progress.streak || 0;
      statBest.textContent = progress.bestStreak || 0;
      statSolved.textContent = (progress.solvedDays ? progress.solvedDays.length : 0) + " / " + TOTAL;
    }

    $("hint").addEventListener("click", useHint);
    $("reset").addEventListener("click", function(){ loadPuzzle(viewIndex); });
    $("flip").addEventListener("click", function(){ orientation = orientation=="w"?"b":"w"; renderBoard(); });
    $("prev").addEventListener("click", function(){ loadPuzzle((viewIndex - 1 + TOTAL) % TOTAL); });
    $("next").addEventListener("click", function(){ loadPuzzle((viewIndex + 1) % TOTAL); });
    $("today").addEventListener("click", function(){ loadPuzzle(TODAY_IDX); });

    var dataUrl = root.getAttribute("data-puzzle-src");
    setStatus("Loading today's position...", "");
    fetch(dataUrl)
      .then(function(r){ return r.json(); })
      .then(function(data){
        PUZZLES = data;
        TOTAL = PUZZLES.length;
        TODAY_IDX = todayIndex();
        loadPuzzle(TODAY_IDX);
      })
      .catch(function(){
        setStatus("Could not load today's puzzle. Please refresh the page.", "is-bad");
      });
  }

  function boot(){
    var roots = document.querySelectorAll('[data-chess-puzzle-root]');
    roots.forEach(function(root){
      if (root.dataset.chessPuzzleInit) return;
      root.dataset.chessPuzzleInit = "1";
      initChessPuzzle(root);
    });
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();